import { Box, RadioButtonGroup, Text } from '@jfs/ui-new'
import React from 'react'

const RadioButtonWithTitle = ({
  data,
  title,
  onChange,
  isChecked,
  horizontalGap,
  color,
  size = 12,
  textSize = 12,
  isFormElement = false,
  setFieldValue,
  fieldName,
  selectedValue,
}: any) => {
  const handleChange = (isChecked: string) => {
    if (setFieldValue && fieldName) {
      setFieldValue(fieldName, isChecked)
    }
  }
  return (
    <Box pv={8} marginRight={8} minWidth={220}>
      <Text title={title} color={'PRIMARY_GREY'} fontSize={12} fontFamily={'jiotype-medium'} lineHeight={18} />
      <RadioButtonGroup
        data={data}
        textSize={textSize}
        size={size}
        textPadding={0}
        minItemHeight={36}
        checked={isChecked}
        horizontalGap={horizontalGap}
        direction={'horizontal'}
        onChange={isFormElement ? handleChange : (isChecked) => onChange(data.type, isChecked)}
        color={color}
        value={selectedValue}
      />
    </Box>
  )
}

export { RadioButtonWithTitle }
